import produce from 'immer';

export const Types = {
  POST_WEBHOOKEVENTINTEGRATION_REQUEST:
    '@webhookEventIntegration/POST_WEBHOOKEVENTINTEGRATION_REQUEST',
  POST_WEBHOOKINTEGRATION_RESPONSE:
    '@webhookEventIntegration/POST_WEBHOOKINTEGRATION_RESPONSE',
  PUT_WEBHOOKEVENTINTEGRATION_REQUEST:
    '@webhookEventIntegration/PUT_WEBHOOKEVENTINTEGRATION_REQUEST',
  PUT_WEBHOOKEVENTINTEGRATION_RESPONSE:
    '@webhookEventIntegration/PUT_WEBHOOKEVENTINTEGRATION_RESPONSE',
  GET_WEBHOOKEVENTSLISTINTEGRATION_REQUEST:
    '@webhookEventIntegration/GET_WEBHOOKEVENTSLISTINTEGRATION_REQUEST',
  GET_WEBHOOKEVENTSLISTINTEGRATION_RESPONSE:
    '@webhookEventIntegration/GET_WEBHOOKEVENTSLISTINTEGRATION_RESPONSE',
  DELETE_WEBHOOKEVENTINTEGRATION_REQUEST:
    '@webhookEventIntegration/DELETE_WEBHOOKEVENTINTEGRATION_REQUEST',
  DELETE_WEBHOOKEVENTINTEGRATION_RESPONSE:
    '@webhookEventIntegration/DELETE_WEBHOOKEVENTINTEGRATION_RESPONSE',
};

const INITIAL_STATE = {
  postWebhookEvent: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  getWebhookEventList: {
    success: false,
    error: null,
    loading: false,
    data: [],
  },
  putWebhookEventIntegration: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  deleteWebhookEventIntegration: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
};

export default function webhookEventIntegration(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.GET_WEBHOOKEVENTSLISTINTEGRATION_REQUEST: {
        draft.getWebhookEventList.loading = true;
        break;
      }
      case Types.GET_WEBHOOKEVENTSLISTINTEGRATION_RESPONSE: {
        draft.getWebhookEventList.loading = false;
        draft.getWebhookEventList.data = action.payload.response;
        draft.getWebhookEventList.success = action.payload.success;
        draft.getWebhookEventList.error = false;
        break;
      }
      case Types.POST_WEBHOOKEVENTINTEGRATION_REQUEST: {
        draft.postWebhookEvent.loading = true;
        break;
      }
      case Types.POST_WEBHOOKINTEGRATION_RESPONSE: {
        draft.postWebhookEvent.loading = false;
        draft.postWebhookEvent.data = action.payload.response;
        draft.postWebhookEvent.success = action.payload.success;
        draft.postWebhookEvent.error = false;
        break;
      }

      case Types.PUT_WEBHOOKEVENTINTEGRATION_REQUEST: {
        draft.putWebhookEventIntegration.loading = true;
        break;
      }
      case Types.PUT_WEBHOOKEVENTINTEGRATION_RESPONSE: {
        draft.putWebhookEventIntegration.loading = false;
        draft.putWebhookEventIntegration.data = action.payload.response;
        draft.putWebhookEventIntegration.success = action.payload.success;
        draft.putWebhookEventIntegration.error = false;
        break;
      }
      case Types.DELETE_WEBHOOKEVENTINTEGRATION_REQUEST: {
        draft.deleteWebhookEventIntegration.loading = true;
        break;
      }
      case Types.DELETE_WEBHOOKEVENTINTEGRATION_RESPONSE: {
        draft.deleteWebhookEventIntegration.loading = false;
        draft.deleteWebhookEventIntegration.data = action.payload.response;
        draft.deleteWebhookEventIntegration.success = action.payload.success;
        draft.deleteWebhookEventIntegration.error = false;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  postWebhookEventIntegrationRequest: (params) => ({
    type: Types.POST_WEBHOOKEVENTINTEGRATION_REQUEST,
    payload: { params },
  }),
  postWebhookEventIntegrationResponse: (response, success) => ({
    type: Types.POST_WEBHOOKINTEGRATION_RESPONSE,
    payload: { response, success },
  }),
  getWebhookEventsListRequest: (webhookId) => ({
    type: Types.GET_WEBHOOKEVENTSLISTINTEGRATION_REQUEST,
    payload: { webhookId },
  }),
  getWebhookEventsListResponse: (response, success) => ({
    type: Types.GET_WEBHOOKEVENTSLISTINTEGRATION_RESPONSE,
    payload: { response, success },
  }),
  putWebhookEventIntegrationRequest: (params) => ({
    type: Types.PUT_WEBHOOKEVENTINTEGRATION_REQUEST,
    payload: { params },
  }),
  putWebhookEventIntegrationResponse: (response, success) => ({
    type: Types.PUT_WEBHOOKEVENTINTEGRATION_RESPONSE,
    payload: { response, success },
  }),
  deleteWebhookEventIntegrationRequest: (idWebhook) => ({
    type: Types.DELETE_WEBHOOKEVENTINTEGRATION_REQUEST,
    payload: idWebhook,
  }),
  deleteWebhookEventIntegrationResponse: (response, success) => ({
    type: Types.DELETE_WEBHOOKEVENTINTEGRATION_RESPONSE,
    payload: { response, success },
  }),
};
